import React, { useCallback, useEffect, useState } from 'react'
import { ApiGet } from '../../helper/axiosFunctions';
import { commonToast } from '../../helper/Toast';
import { formatDate } from '../../helper/commonFunctions';

export default function MaterialAbout({ data }) {
    const [creatorData, setCreatorData] = useState({});
    const [loading, setLoading] = useState(false);
    const DetailRow = ({ label, value, show = true }) => {
        if (!show) return null;
        return (
            <>
                <div className="text-gray-600 text-sm">{label}:</div>
                {loading ? (
                    <div className="font-medium text-gray-900 bg-slate-200 animate-pulse h-5 rounded"></div>
                ) : (
                    <div className="font-medium text-gray-900">
                        {value}
                    </div>
                )}
            </>
        );
    };

    const getCreatorData = useCallback(async () => {
        setLoading(true);
        try {
            const response = await ApiGet(`/users/${data?.authorId}`);
            setCreatorData(response?.data);
        } catch (error) {
            commonToast(error?.data?.error || error?.message, "error");
        } finally {
            setLoading(false);
        }
    }, [data?.authorId])

    useEffect(() => {
        getCreatorData();
    }, [getCreatorData]);
    return (<>
        <div className="space-y-4 mt-5">
            <div className="grid grid-cols-2 gap-4 capitalize">
                <DetailRow label="Deck Name" value={data?.deckName} />
                <DetailRow label="Status" value={data?.status} show={data?.status} />
                <DetailRow
                    label="Author Name"
                    value={`${creatorData?.firstName} ${creatorData?.lastName}`}
                />
                <DetailRow
                    label="Created By"
                    value={`${creatorData?.firstName} ${creatorData?.lastName}`}
                />
                <DetailRow label="Language" value={data?.language} show={data?.language} />
                <DetailRow
                    label="Countries"
                    value={data?.countries?.join(", ")}
                    show={data?.countries?.length > 0}
                />
                <DetailRow
                    label="Creation Date"
                    value={formatDate(data?.creationDate)}
                />
            </div>
            {data?.longDescription && (
                <div className="text-gray-700 text-sm leading-relaxed border-t pt-4">
                    {loading ? (
                        <>
                            <div className="font-medium text-gray-900 bg-slate-200 animate-pulse h-5 rounded"></div>
                        </>
                    ) : (
                        <div className="font-medium text-gray-700">
                            {data.longDescription}
                        </div>
                    )}
                </div>
            )}
        </div>
    </>)
}
